import React, { useState } from 'react';

const ROLES = ['member', 'readonly', 'admin', 'superadmin'];

const UserCreateForm = ({ onSubmit, loading }) => {
  const [form, setForm] = useState({
    email: '',
    password: '',
    display_name: '',
    role: 'readonly',
  });
  const [showPassword, setShowPassword] = useState(false);

  const isValid = form.email.trim() && form.password.length >= 6 && form.display_name.trim();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
    setForm({ email: '', password: '', display_name: '', role: 'readonly' });
  };

  return (
    <div style={{ background: '#f8f8f8', border: '1px solid #ddd', borderRadius: '8px', padding: '20px', marginBottom: '30px' }}>
      <h5 style={{ marginBottom: '16px', color: '#333' }}>Crear usuario del panel</h5>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="form-label">Nombre</label>
            <input
              type="text"
              className="form-control"
              name="display_name"
              placeholder="Ej: Juan Pérez"
              value={form.display_name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="correo@ejemplo.com"
              value={form.email}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Contraseña</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                className="form-control"
                name="password"
                placeholder="Mínimo 6 caracteres"
                value={form.password}
                onChange={handleChange}
                style={{ paddingRight: '40px' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute', top: '50%', right: '10px',
                  transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer',
                  padding: 0, color: '#666', lineHeight: 1,
                }}
                tabIndex={-1}
                aria-label={showPassword ? 'Ocultar contraseña' : 'Ver contraseña'}
              >
                {showPassword ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88L6.59 6.59m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        <div className="row align-items-end">
          <div className="col-md-4 mb-3">
            <label className="form-label">Rol</label>
            <select
              className="form-select"
              name="role"
              value={form.role}
              onChange={handleChange}
            >
              {ROLES.map((r) => (
                <option key={r} value={r}>
                  {r.charAt(0).toUpperCase() + r.slice(1)}
                </option>
              ))}
            </select>
            <small className="text-muted">
              {form.role === 'member' && 'Usuario de la app móvil'}
              {form.role === 'readonly' && 'Solo puede ver el panel'}
              {form.role === 'admin' && 'Puede editar anuncios y notificaciones'}
              {form.role === 'superadmin' && 'Acceso completo a todo el panel'}
            </small>
          </div>
          <div className="col-md-4 mb-3">
            <button
              type="submit"
              className="btn"
              style={{ backgroundColor: '#C73B33', color: '#fff', width: '100%' }}
              disabled={!isValid || loading}
            >
              {loading ? 'Creando...' : 'Crear Usuario'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UserCreateForm;
